var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.0918,
    y: 1.09082,
    width: 21.8182,
    height: 21.8182,
    rx: 2,
    fill: "#1D2E99"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5807 8.00195C17.2474 7.66862 16.7474 7.66862 16.4141 8.00195L10.1641 14.252L7.58073 11.6686C7.2474 11.3353 6.7474 11.3353 6.41406 11.6686C6.08073 12.002 6.08073 12.502 6.41406 12.8353L9.58073 16.002C9.7474 16.1686 9.91406 16.252 10.1641 16.252C10.4141 16.252 10.5807 16.1686 10.7474 16.002L17.5807 9.16862C17.9141 8.83529 17.9141 8.33529 17.5807 8.00195Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.d28d7c61caeeeeb105f49d7d61ea283f.svg";
export { ForwardRef as ReactComponent };